<template>
  <div class="monitoring-slots">
    <div class="actions-wrapper">
      <v-text-field v-model="filters.date_from" label="Дата от" type="date" dense hide-details />
      <v-text-field v-model="filters.date_to" label="Дата до" type="date" dense hide-details />
      <v-text-field v-model="filters.supplier_id" label="ID поставщика" type="number" dense hide-details />
      <v-text-field v-model="filters.werk_id" label="ID РЦ" type="number" dense hide-details />
      <rcc-button color="primary" :is-loading="isDataLoading" @click="loadData">Обновить</rcc-button>
      <rcc-button color="success" @click="download">Выгрузить в Excel</rcc-button>
    </div>
    <div class="rcc-table-list__table-wrapper">
      <rcc-table :page.sync="page" :page-count="pagesCount" :items-per-page="rowsOnTable"
        :headers="headers" :rows="rows" :is-fixed-header="true" :is-loading="isDataLoading" />
    </div>
  </div>
</template>

<script>
import Page from '@/mixins/page'
import TableList from '@/mixins/table-list'
import getXls from '@/utils/get-xls'
import headerData from './headers'
import RccTable from 'Components/table/rcc-table'
import RccButton from 'Components/controls/rcc-button'

export default {
  components: { RccTable, RccButton },
  mixins: [Page, TableList],
  noMixinMount: true,
  data() {
    return { rows: [], pagesCount: 1, isDataLoading: false, filters: {} }
  },
  computed: { headers() { return headerData } },
  watch: { page() { this.loadData() } },
  mounted() { this.loadData() },
  methods: {
    params() {
      return Object.keys(this.filters).reduce((result, key) => {
        if (this.filters[key] !== '' && this.filters[key] != null) result[key] = this.filters[key]
        return result
      }, { page: this.page, page_size: this.rowsOnTable })
    },
    loadData() {
      this.isDataLoading = true
      this.$apiMethods.monitoringSlots.getMonitoringSlots(this.params())
        .then(data => {
          this.pagesCount = data.pages || 1
          this.rows = (data.items || []).map(item => ({
            ...item,
            received_at: item.received_at ? this.$moment(item.received_at).format('DD.MM.YYYY HH:mm:ss') : '',
            slot_time: item.start_time && item.end_time ? `${item.start_time}–${item.end_time}` : '—',
            quantity: item.min_quantity == null
              ? '—'
              : `${item.min_quantity}–${item.max_quantity == null ? '∞' : item.max_quantity}`,
            werk_limits: `${item.werk_min == null ? '—' : item.werk_min}/${item.werk_max == null ? '—' : item.werk_max}`,
            region_limits: `${item.region_min == null ? '—' : item.region_min}/${item.region_max == null ? '—' : item.region_max}`
          }))
        })
        .finally(() => { this.isDataLoading = false })
    },
    download() {
      this.$apiMethods.monitoringSlots.exportMonitoringSlots(this.params()).then(data => getXls.call(this, data))
    }
  }
}
</script>

<style scoped>
.actions-wrapper { display: flex; align-items: center; gap: 12px; padding: 12px 0; }
.actions-wrapper .v-text-field { max-width: 170px; }
</style>
